export const UPDATE_BANK_INFO = "UPDATE_BANK_INFO";
export const UPDATE_KIN_INFO = "UPDATE_KIN_INFO";
export const UPDATE_NIN_INFO = "UPDATE_NIN_INFO";
export const UPDATE_REG_STATUS = "UPDATE_REG_STATUS";
export const NEXT_STEP = "NEXT_STEP";
export const SET_STEP = "SET_STEP";
export const GO_BACK = "GO_BACK";
export const PREVIOUS_STEP = "PREVOUS_STEP";
